import { colors as themeColors } from '../../utils/theme';
import { gradients } from '../../utils/theme';
import { useState, useMemo, useEffect, useCallback } from "react";
import { Box, Button, Checkbox, Typography, TextField, Grid, Paper, IconButton, Stack, Divider, Avatar, Tooltip, InputAdornment, CircularProgress, Snackbar, Alert, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, RadioGroup, Radio, FormControlLabel, Chip, LinearProgress } from '@mui/material';
import { VscNewFile } from 'react-icons/vsc';
import { FaUser } from "react-icons/fa";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import CustomNoDataOverlay from "../../components/CustomNoDataOverlay";
import NoDataComponent from "../../components/NoDataComponent";
import { formatRows } from "../../utils/formatRows";
import DescriptionIcon from '@mui/icons-material/Description';
import SearchIcon from '@mui/icons-material/Search';
import CenterLoader from "../../components/CenterLoader";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import * as XLSX from 'xlsx';
import LoadingOverlay from '../../components/LoadingOverlay';
import SkeletonLoader from '../../components/SkeletonLoader';
import { motion } from 'framer-motion';

const getFinancialYearRange = (now = new Date()) => {
    const month = now.getMonth();
    const startYear = month >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    const from = `${startYear}-04-01`;
    const to = `${startYear + 1}-03-31`;
    return { from, to };
};

const normalizeDate = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split("-").reverse().join("/") : v;
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4',];
    return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
    if (!name) return 'I';
    return name.trim().charAt(0).toUpperCase();
}

const PurchaseOrderDetails = ({ connectionString, pdfString }) => {
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory || null;
    console.log('companyId:', companyId, userId, role)
    const [activeCard, setActiveCard] = useState(null);
    const [loading, setLoading] = useState(false);
    const [genQuoteData, setGenQuoteData] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPopupMode, setFilterPopupMode] = useState('datewise');
    const [filterPopupFromDate, setFilterPopupFromDate] = useState('');
    const [filterPopupToDate, setFilterPopupToDate] = useState('');
    const [filterPopupFirms, setFilterPopupFirms] = useState([]);
    const [firmOptions, setFirmOptions] = useState([]);
    const [firmAllOptions, setFirmAllOptions] = useState([]);
    const [firmInputValue, setFirmInputValue] = useState('');
    const [firmLoading, setFirmLoading] = useState(false);
    const [filterPopupSnapshot, setFilterPopupSnapshot] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [exportExcelEnabled, setExportExcelEnabled] = useState(false);
    const [masterReportData, setMasterReportData] = useState([]);
    const [detailsReportData, setDetailsReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);
    const isEmpty = orders.length === 0;
    // PDF API base (same public host as RN example)
    // const PDF_API_BASE = "http://192.168.1.248:3117";
    const PDF_API_BASE = pdfString;

    // --- NEW: loading states for PDF actions ---
    // show the global "Preparing PDF..." indicator (like other pages)
    const [pdfLoading, setPdfLoading] = useState(false);
    // show loading spinner for a specific row's eye icon
    const [loadingPdfId, setLoadingPdfId] = useState(null);
    const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
    // ------------------------------------------------
    // Columns definition moved after handleViewClick & handleDelete to avoid "before initialization" error

    const params = {
        userId,
        userCategory: role,
        companyId
    };

    const api = connectionString;

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${api}/api/Purchaseorders`, {
                    params,
                    headers: {
                        'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
                    }
                });
                console.log(res.data);
                setOrders(formatRows(res.data || []));
            } catch (err) {
                console.error('Failed to fetch orders', err);
                if (err.response && err.response.status === 304) {
                    setOrders([]);
                }
            } finally {
                setLoading(false);
            }
        })();
    }, []); // kept as original

    const handleExport = async () => {
        try {
            const response = await axios.get(`${api}/api/inqdetails/search?mode=export&companyId=${companyId}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'InquiryExport.xlsx');
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error exporting:', error);
            setSnackbarMessage("Failed to export data.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            setTimeout(() => {
                setSnackbarOpen(false);
            }, 3000);
        }
    };

    const filteredOrders = useMemo(() => {
        if (!filterText.trim()) return orders;

        const lower = filterText.toLowerCase();
        return orders.filter((row) =>
            String(row.PONumber || "").toLowerCase().includes(lower) ||
            String(row.PartyName || "").toLowerCase().includes(lower) ||
            String(row.ContactPerson || "").toLowerCase().includes(lower)
        );
    }, [filterText, orders]);

    const handleDelete = (ids) => {
        if (!ids || ids.length === 0) {
            setSnackbarMessage("No orders selected for deletion.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            setTimeout(() => setSnackbarOpen(false), 3000);
            return;
        }

        setPendingDeleteIds(ids.map(Number));
        setOpenDeleteDialog(true);
    };



    // const confirmDelete  = async () => {
    //    const ids = pendingDeleteIds;
    // if (!ids.length) return;

    // setOpenDeleteDialog(false);

    //     console.log("Deleting IDs:", ids);

    //     try {
    //         const payload = { objAryId: ids, companyId, userId };
    //         const { data } = await axios.post(`${api}/api/delete-PurcOrders`, payload);

    //         console.log("Delete API response:", data);

    //         const referencedIds = data.referencedIds || [];
    //         const hasReferences = referencedIds.length > 0;
    //         const totalDeleted = (data.deletedOrders || 0) + (data.deletedPurchaseOrderDetailss || 0);

    //         if (totalDeleted > 0) {
    //             setOrders(prev => prev.filter(row => !ids.includes(Number(row.POId)) || referencedIds.includes(Number(row.POId))));
    //             setSelectionModel(prev => prev.filter(id => referencedIds.includes(id)));
    //             setSnackbarMessage(`Deleted ${data.deletedOrders || 0} orders and ${data.deletedPurchaseOrderDetailss || 0} details.`);
    //             setSnackbarSeverity("success");
    //             setSnackbarOpen(true);
    //             setTimeout(() => { setSnackbarOpen(false); }, 3000);
    //         }

    //         if (hasReferences) {
    //             setSnackbarMessage(`The following ID(s) have references and cannot be deleted: ${referencedIds.join(', ')}`);
    //             setSnackbarSeverity("warning");
    //             setSnackbarOpen(true);
    //             setTimeout(() => { setSnackbarOpen(false); }, 3000);
    //         } else if (totalDeleted === 0) {
    //             setSnackbarMessage("No orders deleted, possibly due to references.");
    //             setSnackbarSeverity("warning");
    //             setSnackbarOpen(true);
    //             setTimeout(() => { setSnackbarOpen(false); }, 3000);
    //         }
    //     } catch (err) {
    //         console.error('Error deleting orders:', err);
    //         setSnackbarMessage("Failed to delete one or more orders.");
    //         setSnackbarSeverity("error");
    //         setSnackbarOpen(true);
    //         setTimeout(() => { setSnackbarOpen(false); }, 3000);
    //     }
    //      finally {
    //     setPendingDeleteIds([]);
    // }
    // };

    const confirmDelete = async () => {
        const ids = pendingDeleteIds;
        if (!ids.length || deleting) return;

        setDeleting(true);

        console.log("Deleting IDs:", ids);

        try {
            const payload = { objAryId: ids, companyId, userId };
            const { data } = await axios.post(`${api}/api/delete-PurcOrders`, payload);

            console.log("Delete API response:", data);

            // ✅ ALWAYS TRUST IDS, NOT COUNTS
            const deletedIds = data.deletedIds || [];
            const referencedIds = data.referencedIds || [];

            const deletedCount = deletedIds.length;
            const hasReferences = referencedIds.length > 0;

            // ✅ UPDATE UI — REMOVE ONLY ACTUALLY DELETED ROWS
            if (deletedCount > 0) {
                setOrders(prev =>
                    prev.filter(row => !deletedIds.includes(Number(row.POId)))
                );

                // ✅ KEEP REFERENCED ROWS SELECTED
                setSelectionModel(prev =>
                    prev.filter(id => referencedIds.includes(Number(id)))
                );
            }

            // ✅ BUILD CLEAR MESSAGE (SINGLE SNACKBAR)
            let messageParts = [];

            // if (deletedCount > 0) {
            //     messageParts.push(`Deleted Successfully`);
            // }
            if (deletedCount > 0) {
                setSnackbarMessage("Deleted Successfully.");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            }


            if (hasReferences && deletedCount <= 0) {
                setSnackbarMessage("Cannot delete the selected item(s) because they are referenced in other records.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
            }

            // setSnackbarMessage(messageParts.join(' | '));

            // setSnackbarSeverity(
            //     deletedCount > 0 && hasReferences
            //         ? "warning"
            //         : deletedCount > 0
            //             ? "success"
            //             : "info"
            // );

            // setSnackbarOpen(true);

        } catch (err) {
            console.error('Error deleting orders:', err);
            setSnackbarMessage("Failed to delete one or more orders.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setDeleting(false);
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
        }
    };


    const openFilterPopup = useCallback(() => {
        const { from, to } = getFinancialYearRange(new Date());
        const fromDate = filterPopupFromDate || from;
        const toDate = filterPopupToDate || to;
        if (!filterPopupFromDate) setFilterPopupFromDate(fromDate);
        if (!filterPopupToDate) setFilterPopupToDate(toDate);
        setFilterPopupSnapshot({ mode: filterPopupMode, fromDate, toDate, firms: filterPopupFirms });
        setFilterPopupOpen(true);
    }, [filterPopupFromDate, filterPopupToDate, filterPopupMode, filterPopupFirms]);

    const cancelFilterPopup = useCallback(() => {
        if (filterPopupSnapshot) {
            setFilterPopupMode(filterPopupSnapshot.mode);
            setFilterPopupFromDate(filterPopupSnapshot.fromDate);
            setFilterPopupToDate(filterPopupSnapshot.toDate);
            setFilterPopupFirms(filterPopupSnapshot.firms || []);
        }
        setFilterPopupOpen(false);
    }, [filterPopupSnapshot]);

    const handleFilterOk = useCallback(async () => {
        setExportExcelEnabled(true);

        if (!companyId) {
            setSnackbarMessage('Company not selected');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        if (!filterPopupFromDate || !filterPopupToDate) {
            setSnackbarMessage('Please select date range');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        setReportLoading(true);

        try {
            const filterParams = {
                companyId,
                fromDate: filterPopupFromDate,
                toDate: filterPopupToDate,
                mode: filterPopupMode,
                firms: filterPopupFirms.length > 0
                    ? filterPopupFirms.map(f => f.id).join(',')
                    : '',
            };

            const response = await axios.get(
                `${api}/api/purchase-order-register`,
                { params: filterParams }
            );

            const masterData = response?.data?.master?.data || [];
            const detailsData = response?.data?.details?.data || [];

            setMasterReportData(masterData);
            setDetailsReportData(detailsData);

            setSnackbarMessage(`Report loaded: ${masterData.length} master records, ${detailsData.length} detail records`);
            setSnackbarSeverity('success');
            setSnackbarOpen(true);

            console.log('Master Report Data:', masterData);
            console.log('Details Report Data:', detailsData);

        } catch (err) {
            console.error('Error fetching report data:', err);
            setSnackbarMessage(err?.response?.data?.message || 'Failed to fetch report data');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setReportLoading(false);
        }
    }, [
        companyId,
        filterPopupFromDate,
        filterPopupToDate,
        filterPopupMode,
        filterPopupFirms,
        api
    ]);

    const handleExportExcel = useCallback(() => {
        if (!masterReportData.length && !detailsReportData.length) {
            setSnackbarMessage('No data to export. Please apply filters first.');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        const formatDate = (val) => {
            if (!val) return '';
            const s = String(val).split('T')[0];
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const [y, m, d] = s.split('-');
                return `${d}-${m}-${y}`;
            }
            return val;
        };

        const buildSheet = (data, columns) => {
            const header = columns.map(c => c.header);
            const rows = data.map(row =>
                columns.map(c => {
                    const val = row[c.key] ?? '';
                    if (c.isDate) return formatDate(val);
                    if (val === 0 || val === '0' || val === 0.0) return '';
                    // Numeric columns often arrive from the API as strings (e.g. SQL
                    // DECIMAL fields serialized as text). aoa_to_sheet writes cells
                    // based on the JS value's type, so a string here becomes a text
                    // cell that Excel's status bar (Sum/Average) will not aggregate.
                    // Coerce to a real number so these columns total correctly.
                    if (c.isNumeric) {
                        const num = Number(val);
                        return Number.isNaN(num) ? val : num;
                    }
                    return val;
                })
            );
            return XLSX.utils.aoa_to_sheet([header, ...rows]);
        };

        // ✅ TransactionType REMOVED
        const masterColumns = [
            { key: 'PODate', header: 'BillDate', isDate: true },
            { key: 'PONumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'GSTCEssAmt', header: 'GSTCessAmt', isNumeric: true },
            { key: 'BillAmt', header: 'BillAmt', isNumeric: true },
            { key: 'Remark', header: 'Remark' },
        ];

        // ✅ TransactionType REMOVED
        const detailsColumns = [
            { key: 'PODate', header: 'BillDate', isDate: true },
            { key: 'PONumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'itemCode', header: 'ItemCode' },
            { key: 'description', header: 'Description' },
            { key: 'HSNNo', header: 'HSNNo' },
            { key: 'Unit', header: 'Unit' },
            { key: 'QTY', header: 'Qty', isNumeric: true },
            { key: 'Rate', header: 'Rate', isNumeric: true },
            { key: 'Disc', header: 'Disc', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'CGSTRate', header: 'CGSTRate', isNumeric: true },
            { key: 'SGSTRate', header: 'SGSTRate', isNumeric: true },
            { key: 'IGSTRate', header: 'IGSTRate', isNumeric: true },
            { key: 'CESSRate', header: 'CESSRate', isNumeric: true },
            { key: 'UTGSTRate', header: 'UTGSTRate', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'CESSAmt', header: 'CESSAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'ItemRemark', header: 'ItemRemark' },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, buildSheet(masterReportData, masterColumns), 'Master');
        XLSX.utils.book_append_sheet(wb, buildSheet(detailsReportData, detailsColumns), 'Details');

        const fromDate = filterPopupFromDate || 'start';
        const toDate = filterPopupToDate || 'end';
        XLSX.writeFile(wb, `PurchaseOrderRegister_${fromDate}_${toDate}.xlsx`);

        setSnackbarMessage('Excel exported successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
    }, [masterReportData, detailsReportData, filterPopupFromDate, filterPopupToDate]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!api || !companyId) return;
        let active = true;
        const fetchAllFirms = async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${api}/api/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setFirmAllOptions(opts);
                if (!(firmInputValue || '').trim()) setFirmOptions(opts);
            } catch (err) {
                if (!active) return;
                setFirmAllOptions([]);
                setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        };
        fetchAllFirms();
        return () => { active = false; };
    }, [companyId, api, filterPopupOpen]);

    useEffect(() => {
        if (!(firmInputValue || '').trim()) {
            setFirmOptions(firmAllOptions);
            return;
        }
        const q = firmInputValue.toLowerCase();
        setFirmOptions(firmAllOptions.filter(o => o.label.toLowerCase().includes(q)));
    }, [firmInputValue, firmAllOptions]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleViewClick = async (poId) => {
        if (!poId || pdfLoading) return;

        // Show loading states
        setPdfLoading(true);
        setLoadingPdfId(poId);
        setPdfOverlayVisible(true);

        const userIdSafe = userId || 'usr1';
        let formatId = 'format_1';
        let bookNameToSend = 'PurchaseOrder';
        let bookIdToSend = null;

        // === Keep your existing format detection logic (unchanged) ===
        let matchedFormat = null;
        try {
            // ✅ Add cache-buster to get fresh data
            const cacheBreaker = new Date().getTime();
            const resp = await axios.get(`${api}/api/companies`, { params: { companyId, t: cacheBreaker } });
            let comps = [];
            if (Array.isArray(resp?.data)) comps = resp.data;
            else if (resp?.data?.companies) comps = resp.data.companies;
            else if (resp?.data) comps = [resp.data];

            let match = null;
            for (const c of comps) {
                if (Array.isArray(c.formats)) {
                    for (const f of c.formats) {
                        const bn = (f.BookName || f.bookName || '').replace(/\s/g, '');
                        const fn = (f.FormName || f.formName || '').replace(/\s/g, '');
                        if (/^purchaseorder$/i.test(bn) || /^purchaseorder$/i.test(fn)) {
                            match = { company: c, format: f };
                            break;
                        }
                    }
                    if (match) break;
                }
                if ((c.BookName || c.bookName || '').toLowerCase().includes('purchaseorder')) {
                    match = { company: c, format: c };
                    break;
                }
            }

            if (match) {
                const f = match.format;
                const foundBookId = f.BookID ?? f.BookId ?? f.bookId ?? null;
                if (foundBookId) {
                    formatId = `format_${foundBookId}`;
                    bookIdToSend = foundBookId;
                } else if (f.FormName || f.formName) {
                    formatId = String(f.FormName || f.formName);
                }
                bookNameToSend = f.BookName ?? f.bookName ?? bookNameToSend;
                // ✅ Store matched format for Signature checking (fresh from API)
                matchedFormat = f;
            }
        } catch (err) {
            console.warn("Format detection failed, using defaults", err);
        }

        let imageBase64 = null;
        let signatureBase64 = null;
        try {
            const iconRes = await axios.get(`${api}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                const raw = iconRes.data.imageBase64;
                imageBase64 = typeof raw === 'string'
                    ? raw.split('base64,').pop()?.replace(/\s/g, '') || null
                    : null;
            }
            if (iconRes?.data?.signatureBase64) {
                signatureBase64 = iconRes.data.signatureBase64;
            }
        } catch (err) {
            console.warn("Failed to fetch company icon:", err);
        }
        // ✅ Use matched format's Signature (fresh from API, not cached context)
        if (!matchedFormat?.Signature) signatureBase64 = null;

        try {
            // 1. Fetch full Purchase Order data from your main backend
            const poResp = await axios.get(`${api}/api/get-purchase-order-data/${poId}`, {
                params: { companyId },
                headers: { "Cache-Control": "no-store" }
            });

            console.log(poResp);

            const { master, details, company, termsAndConditions, additionalChargeItems } = poResp.data || {};
            if (!master) throw new Error("No master data returned");
            const termsText = Array.isArray(termsAndConditions) && termsAndConditions.length > 0
                ? termsAndConditions
                    .sort((a, b) => a.SrNo - b.SrNo)
                    .map(t => `# ${t.TermsDescription}`)
                    .join('\n')
                : null;

            // 2. Build items array
            const items = (details || []).map(d => {
                const qty = Number(d.Qty) || 0;
                const rate = Number(d.Rate) || 0;
                const disc = Number(d.Disc) || 0;
                const amount = qty * rate * (1 - disc / 100);

                return {
                    hsnCode: d.HSNNo || "",
                    ItemCode: d.itemCode,
                    description: d.productDescription || "",
                    Remark: d.Remark || "",
                    qty: d.Qty || "",
                    rate: d.Rate || "",
                    Unit: d.Unit || "",
                    discount: d.Disc || "",
                    cgst: Number(d.CGST || 0),
                    sgst: Number(d.SGST || 0),
                    igst: Number(d.IGST || 0),
                    TaxableAmt: Number(d.TaxableAmt) || 0,
                    amount,
                };
            });

            // ✅ NEW: Additional Charges
            const additionalCharges = [1, 2, 3, 4, 5]
                .map(slot => {
                    const chargeItem = (additionalChargeItems || []).find(ci => Number(ci.TransType) === 199 + slot);
                    return {
                        name: chargeItem?.description || `Charge ${slot}`,
                        amount: Number(master[`Adc${slot}Amt`]) || 0,
                    };
                })
                .filter(c => c.amount > 0);

            // 3. Build complete pdfData payload
            const pdfData = {
                companyId: companyId,
                companyName: master.FirmName || "",
                address: master.Address || "",
                phone: master.MobileNo || "",
                gstNo: master.GSTNo || "",
                invoiceNo: master.PONumber || "",
                referrenceNo: master.PartyPONO || master.RefNo || "",
                date: master.PODate ? normalizeDate(master.PODate) : "",
                transport: master.Transporter || "SELF",
                challanNo: master.lrNumber || "",
                poNo: master.Project || "",
                state: master.state || "",
                stateCode: master.StateCode || "",
                LrNo: master.lrNumber || "",
                vehNo: master.vehicleNumber || "",
                LrDate: master.lrDate ? normalizeDate(master.lrDate) : "",
                shipToGstNumber: master.shipToGstNumber || "",
                shipToState: master.state || "",
                items,
                toEmail: master.EmailId || "",
                totalAmount: master.grandTotal || 0,
                mobileNo: master.MobileNo || "",
                basicAmount: Number(master.TaxableAmt) || 0,
                additionalCharges,
                CGSTAmt: Number(master.CGSTAmt) || 0,
                SGSTAmt: Number(master.SGSTAmt) || 0,
                IGSTAmt: Number(master.IGSTAmt) || 0,
                RoundOff: Number(master.RoundOff) || 0,
                BillAmt: Number(master.BillAmt) || 0,
                clientState: master.clientState || "",
                clientStateCode: master.clientStateCode || "",
                imageBase64: imageBase64 || null,
                Remark: master.Remark || null,
                termsAndConditions: termsText,
                PaymentTerm: master.PaymentTerm || null,
            };

            // Optional: company header from selectedCompany
            const companyHeader = company ? {
                CompId: companyId,
                CompanyName: company.CompanyName || company.companyName || "",
                Address: company.Address || company.address || "",
                MobileNo: company.MobileNo || company.mobileNo || "",
                EmailId: company.EmailId || "",
                Website: company.Website || "",
                GSTNo: company.GSTNo || company.gstNo || "",
                imageBase64: imageBase64 || null,
                signatureBase64: signatureBase64 || null,
                city: company.City || null,
                BkName1: company.BkName1 || null,
                BkBranch1: company.BkBranch1 || null,
                BkAcNo1: company.BkAcNo1 || null,
                BkIFSCCode1: company.BkIFSCCode1 || null,
                // ✅ NEW: Include Color from matchedFormat for PDF rendering
                headerColor: matchedFormat?.Color || themeColors.neutral.black,
            } : null;

            // 4. POST to PDF backend with full data + logo
            const pdfResp = await axios.post(
                `${PDF_API_BASE}/api/pdf/PurchaseOrder/${encodeURIComponent(poId)}`,
                {
                    docId: poId,
                    userId: userIdSafe,
                    formatId,
                    data: pdfData,
                    company: companyHeader
                },
                { responseType: "blob" }
            );

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");

            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            // (old code : commented to implement pdf view in webview)
            // const newWin = window.open(blobUrl, "_blank");
            // if (newWin) {
            //     newWin.focus();
            //     const timer = setInterval(() => {
            //         if (newWin.closed) {
            //             URL.revokeObjectURL(blobUrl);
            //             clearInterval(timer);
            //         }
            //     }, 1000);
            // } else {
            //     setSnackbarMessage("Popup blocked – PDF opened in same tab");
            //     setSnackbarSeverity("warning");
            //     setSnackbarOpen(true);
            //     window.location.href = blobUrl;
            // }

            // (new code : Added to handle pdf in web and mobile both using webview)
            if (window.ReactNativeWebView) {

                const reader = new FileReader();

                reader.onloadend = () => {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "OPEN_PDF",
                            base64: reader.result
                        })
                    );
                };

                reader.readAsDataURL(blob);

            } else {

                const newWin = window.open(blobUrl, "_blank");
                if (newWin) {
                    newWin.focus();
                    const timer = setInterval(() => {
                        if (newWin.closed) {
                            URL.revokeObjectURL(blobUrl);
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    setSnackbarMessage("Popup blocked – PDF opened in same tab");
                    setSnackbarSeverity("warning");
                    setSnackbarOpen(true);
                    window.location.href = blobUrl;
                }
            }

        } catch (err) {
            console.error("Purchase Order PDF Error:", err);
            setSnackbarMessage("Failed to generate Purchase Order PDF");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setPdfLoading(false);
            setLoadingPdfId(null);
            setPdfOverlayVisible(false);
        }
    };

    // ---------------- MOBILE CARD VIEW ----------------
    const renderMobileCards = () => {
        if (loading) return <SkeletonLoader count={3} height={120} />;
        if (filteredOrders.length === 0) return <Typography textAlign="center" py={6} color="text.secondary"><CustomNoDataOverlay /></Typography>;

        return filteredOrders.map((row) => {
            const isSelected = selectionModel.includes(row.POId);
            const avatarColor = stringToColor(row.PartyName);
            const initials = getInitials(row.PartyName);

            return (
                <Card
                    key={row.POId}
                    onClick={() => navigate(`/main/Purchase-OrderMaster-edit/${row.POId}`)}
                    sx={{ mb: 2, borderLeft: `6px solid ${themeColors.primary.dark}`, borderRadius: 2, overflow: 'hidden', boxShadow: 3, bgcolor: 'background.paper', cursor: 'pointer', '&:hover': { boxShadow: 6 }, }}
                >

                    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
                        {/* Top Row */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                                {role !== "User" && (
                                    <Checkbox
                                        checked={isSelected}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            setSelectionModel(prev =>
                                                prev.includes(row.POId)
                                                    ? prev.filter(i => i !== row.POId)
                                                    : [...prev, row.POId]
                                            );
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        size="small"
                                    />
                                )}

                                <Avatar sx={{ bgcolor: avatarColor, color: themeColors.neutral.surface, width: 36, height: 36, flexShrink: 0 }}>
                                    {initials}
                                </Avatar>

                                <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }} noWrap>
                                        {row.PartyName || '—'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {row.City && row.state ? `${row.City}, ${row.state}` : row.City || row.state || '—'}
                                    </Typography>
                                </Box>
                            </Box>

                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                                {normalizeDate(row.PODate)}
                            </Typography>
                        </Box>

                        {/* Order No + Amount */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.PONumber || '—'}
                                </Typography>
                            </Box>

                            {role !== "SalesMan" && (
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    ₹{Number(row.BillAmt || 0).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </Typography>
                            )}
                        </Box>

                        {/* Ref No */}
                        {row.PartyPONO && (
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                                    Ref:
                                </Typography>
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.PartyPONO}
                                </Typography>
                            </Box>
                        )}

                        <Divider sx={{ my: 1.5 }} />

                        {/* Bottom Row */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <FaUser color={themeColors.warning.main} style={{ marginRight: 6 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.ContactPerson || '—'}
                                </Typography>
                            </Box>

                            <IconButton
                                color="primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row.POId);
                                }}
                            >
                                {loadingPdfId === row.POId
                                    ? <CircularProgress size={20} />
                                    : <PrintIcon />}
                            </IconButton>
                        </Box>
                    </CardContent>
                </Card>
            );
        });
    };


    // ------------------ end handleViewClick ------------------

    // Columns defined here (after handleViewClick & handleDelete) to avoid reference-before-initialization
    const columns = useMemo(() => {
        const cols = [
            {
                field: "PODate", headerName: "PO Date", flex: 0.8, sortable: true, filterable: true,
                valueGetter: (value) => {
                    if (typeof value !== "string" || !value.includes("-")) return "-";
                    const [yyyy, mm, dd] = value.split("T")[0].split("-");
                    return `${dd}/${mm}/${yyyy}`;
                },
            },
            {
                field: "PONumber", headerName: "PO No.", flex: 1.2,
                renderCell: (params) => (
                    <Box onClick={() => navigate(`/main/Purchase-OrderMaster-edit/${params.row.POId}`)} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} >
                        {params.value}
                    </Box>
                ),
            },
            // { field: "PartyPONO", headerName: "Ref No.", flex: 1, },
            {
                field: "PartyName", headerName: "FirmName", flex: 2.5,
                renderCell: (params) => (
                    <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <FaUser color={themeColors.warning.main} />
                            <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
                        </Stack>
                        <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
                    </Box>
                ),
            },
            {
                field: "City",
                headerName: "Location",
                flex: 1.5,
                filterable: true,
                valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
                renderCell: (params) => {
                    // console.log("Location cell params:", params);
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="body2">
                                {params.row.City || '-'}
                            </Typography>
                            <Typography variant="caption" sx={{ color: themeColors.neutral.sub }}>
                                {params.row.state || '-'}
                            </Typography>
                        </Box>
                    );
                },
            },


            ...(user?.UserCategory !== "SalesMan"
                ? [
                    {
                        field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
                        valueFormatter: (params) => {
                            let num = Number(params);
                            if (typeof num === "string") {
                                num = parseFloat(num);
                            }
                            if (typeof num !== "number" || isNaN(num)) return "-";
                            return `₹${num.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}`;
                        },
                    },
                ]
                : []),
            {
                field: "view",
                headerName: "View",
                filterable: false,
                flex: 0.4,
                sortable: false,
                align: "right",
                headerAlign: "right",
                renderCell: (params) => {
                    // If this row's POId is currently loading, show a small spinner
                    const thisId = params.row.POId;
                    if (loadingPdfId && String(loadingPdfId) === String(thisId)) {
                        return <CircularProgress size={20} />;
                    }

                    // Stop propagation on click so DataGrid doesn't select the row.
                    return (
                        <IconButton
                            color="primary"
                            onClick={(e) => {
                                // prevent row selection and other side-effects
                                e.stopPropagation();
                                e.preventDefault();
                                // call your PDF opener
                                handleViewClick(params.row.POId);
                            }}
                        >
                            <PrintIcon />
                        </IconButton>
                    );
                },
            },
        ];

        if (role !== "User") {
            cols.push({
                field: "delete",
                headerName: "Delete",
                filterable: false,
                flex: 0.4,
                sortable: false,
                align: "right",
                headerAlign: "right",
                renderCell: (params) => {
                    const isSelected = params.api.isRowSelected(params.id);

                    return (
                        <Tooltip
                            title={
                                isSelected
                                    ? "Delete selected orders"
                                    : "Select row to enable delete"
                            }
                        >
                            <span>
                                <IconButton
                                    color="error"
                                    size="small"
                                    aria-label={isSelected ? "delete" : "select-to-enable-delete"}
                                    disabled={!isSelected}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const selMap = params.api.getSelectedRows();
                                        const selectedIds = Array.from(selMap.keys()).map(Number);
                                        handleDelete(selectedIds);
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    );
                },
            });
        }

        return cols;
    }, [user?.UserCategory, role, loadingPdfId, navigate, handleViewClick, handleDelete]);

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            {/* ── Module Header ──────────────────────────────────────────── */}
            <Box sx={{ mb: 1.5 }}>
                <Box sx={{ height: 4, background: gradients.primaryRow, borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Purchase Orders
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="outlined" size="small" startIcon={<FilterAltIcon />} onClick={openFilterPopup} sx={{ textTransform: 'none' }}>Filter</Button>
                        <Button variant="contained" size="small" startIcon={<AddIcon />} component={Link} to="/main/Purchase-OrderMaster-stepper">
                            {isSmallDevice ? 'Add' : 'Add Purchase Order'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            <Paper sx={{ borderRadius: 1, mt: 1, maxWidth: `calc(100%)` }}>
                {!loading && (
                    <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                        <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                            {!isDesktop && (
                                <Box sx={{ mb: 2, px: 1 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Search Purchase Orders..."
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined"
                                    />
                                </Box>
                            )}

                            {!isDesktop && role !== 'User' && selectionModel.length > 0 && (
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
                                    <Box display="flex" alignItems="center">
                                        <Checkbox
                                            checked={
                                                filteredOrders.length > 0 &&
                                                filteredOrders.every(r =>
                                                    selectionModel.includes(r.POId)
                                                )
                                            }
                                            onChange={() => {
                                                const allSelected =
                                                    filteredOrders.length > 0 &&
                                                    filteredOrders.every(r =>
                                                        selectionModel.includes(r.POId)
                                                    );

                                                if (allSelected) {
                                                    setSelectionModel([]);
                                                } else {
                                                    setSelectionModel(
                                                        filteredOrders.map(r => r.POId)
                                                    );
                                                }
                                            }}
                                        />

                                        <Typography>
                                            {selectionModel.length} selected
                                        </Typography>
                                    </Box>
                                    <Tooltip title="Delete selected">
                                        <IconButton color="error" onClick={() => handleDelete(selectionModel)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            )}

                            <Paper elevation={2} sx={{ borderRadius: 3, p: 0.5, overflow: 'hidden' }}>
                                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Typography variant='h6' fontWeight={600}>Purchase Order List</Typography>
                                </Box> */}
                                {isDesktop ? (
                                    <Box sx={{ height: '71vh', width: '100%', position: 'relative' }}>
                                        <LoadingOverlay isVisible={loading} />
                                        {isEmpty && !loading && <NoDataComponent />}
                                        {!loading && !isEmpty && <DataGrid
                                                    rows={orders}
                                                    getRowHeight={() => 'auto'}
                                                    columns={columns}
                                                    getRowId={(row) => row.POId}
                                                    pageSizeOptions={[50, 100]}
                                                    checkboxSelection={role !== "User"}
                                                    rowSelectionModel={selectionModel}
                                                    onRowSelectionModelChange={(newSel) => setSelectionModel(newSel.map(Number))}
                                                    disableRowSelectionOnClick
                                                    // ❌ REMOVE autoHeight when there's no data
                                                    slots={{
                                                        noResultsOverlay: CustomNoDataOverlay
                                                    }}
                                                    sx={{
                                                        // // ✅ Conditional height based on data
                                                        // height: isEmpty ? '400px' : 'auto',
                                                        // minHeight: isEmpty ? '400px' : '550px',

                                                        // // ✅ Overlay wrapper ko full height do
                                                        // '& .MuiDataGrid-overlayWrapper': {
                                                        //     height: '100%',
                                                        //     minHeight: '400px',
                                                        // },

                                                        // Column header styling
                                                        '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                                        '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                        '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

                                                        // Background styling
                                                        '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                                        '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },

                                                        // Row styling
                                                        '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
                                                        '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                                        '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },

                                                        // Selected row styling
                                                        '& .MuiDataGrid-row.Mui-selected': {
                                                            backgroundColor: `${themeColors.primary.selected} !important`
                                                        },

                                                        // Cell content alignment
                                                        '& .MuiDataGrid-cell': {
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        },
                                                    }}
                                                />}
                                    </Box>
                                ) : (
                                    <Box sx={{ px: 0.5 }}>
                                        {loading && <SkeletonLoader count={2} height={120} />}
                                        {!loading && isEmpty && <NoDataComponent />}
                                        {!loading && !isEmpty && renderMobileCards()}
                                    </Box>
                                )}

                            </Paper>
                        </Box>

                    </Paper>
                )}
            </Paper>

            {/* Global PDF loading indicator (mirrors your other code) */}
            {pdfLoading && (
                <Box sx={{ mt: 2, mx: 'auto', width: '97%', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={18} /> <Typography>Preparing PDF...</Typography>
                </Box>
            )}

            {pdfOverlayVisible && (
                <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ textAlign: 'center', bgcolor: '#111', p: '40px 60px', borderRadius: '20px' }}>
                        <CircularProgress size={60} thickness={4} sx={{ color: themeColors.neutral.surface }} />
                        <Typography variant="h6" sx={{ color: themeColors.neutral.surface, mt: 3 }}>Generating Purchase Order PDF…</Typography>
                        <Typography variant="body2" sx={{ color: themeColors.neutral.muted, mt: 1 }}>Please wait</Typography>
                    </Box>
                </Box>
            )}

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }} variant="filled">
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={openDeleteDialog} onClose={() => { if (!deleting) setOpenDeleteDialog(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: gradients.danger }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{pendingDeleteIds.length}</Typography>
                        {' '}purchase order(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setOpenDeleteDialog(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Filter Dialog */}
            <Dialog
                open={filterPopupOpen}
                onClose={cancelFilterPopup}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1.5,
                        pt: 2,
                        px: 3,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                p: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <FilterListIcon sx={{ color: 'white', fontSize: 20 }} />
                        </Box>
                        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                            Filter Options
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={cancelFilterPopup}
                        size="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2, bgcolor: themeColors.neutral.surfaceAlt }}>
                    {/* Filter Mode Selection */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            mb: 1,
                            mt: 1,
                            bgcolor: 'white',
                            border: `1px solid ${themeColors.neutral.line}`,
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'text.primary' }}>
                                Filter Mode
                            </Typography>
                        </Box>
                        <RadioGroup
                            row
                            value={filterPopupMode}
                            onChange={(e) => setFilterPopupMode(e.target.value)}
                            sx={{ display: 'flex', gap: 2 }}
                        >
                            <FormControlLabel
                                value="datewise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': { color: 'primary.main' }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            📅 Datewise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'datewise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                            <FormControlLabel
                                value="partywise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': {
                                                color: 'primary.main',
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            👥 Partywise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'partywise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                        </RadioGroup>
                    </Paper>

                    {/* Filter Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Date Range */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#ff6b6b', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📆 Date Range
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        From Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupFromDate}
                                        onChange={(e) => setFilterPopupFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        To Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupToDate}
                                        onChange={(e) => setFilterPopupToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Paper>

                        {/* Firm Name */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#4ecdc4', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    🏢 Firm Name
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={firmOptions}
                                value={filterPopupFirms}
                                loading={firmLoading}
                                inputValue={firmInputValue}
                                onInputChange={(_, v) => setFirmInputValue(v)}
                                onChange={(_, v) => setFilterPopupFirms(v)}
                                getOptionLabel={o => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#4ecdc4',
                                                '&.Mui-checked': { color: '#4ecdc4' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupFirms?.length ? `${filterPopupFirms.length} firm(s) selected` : 'Select firms (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupFirms?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupFirms.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#4ecdc4',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {firmLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={props => <Paper elevation={4} {...props} />}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>
                    </Box>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        bgcolor: themeColors.neutral.surfaceAlt,
                        borderTop: `1px solid ${themeColors.neutral.line}`,
                        gap: 2
                    }}
                >
                    <Button
                        onClick={cancelFilterPopup}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            borderColor: themeColors.neutral.line,
                            color: 'text.secondary',
                            '&:hover': { borderColor: themeColors.neutral.muted, bgcolor: themeColors.neutral.surfaceMuted }
                        }}
                    >
                        ✕ Cancel
                    </Button>

                    {/* Export Excel Button */}
                    <Button
                        onClick={handleExportExcel}
                        variant="outlined"
                        disabled={!exportExcelEnabled}
                        sx={{
                            flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600, py: 1.2,
                            borderColor: !exportExcelEnabled ? themeColors.neutral.line : themeColors.success.dark,
                            color: !exportExcelEnabled ? 'text.disabled' : themeColors.success.dark,
                            '&:hover': {
                                borderColor: themeColors.success.dark,
                                bgcolor: '#f1f8e9'
                            },
                            '&.Mui-disabled': {
                                borderColor: themeColors.neutral.line,
                                color: 'text.disabled'
                            }
                        }}
                    >
                        📊 Export Excel
                    </Button>

                    <Button
                        onClick={handleFilterOk}
                        variant="contained"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
                                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)'
                            }
                        }}
                    >
                        ✓ Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
};

export default PurchaseOrderDetails;












// import { useState, useMemo, useEffect } from "react";
// import { Box, Paper, IconButton, Typography, Grid, CircularProgress, Snackbar, Alert, TextField, InputAdornment, Divider, Avatar, Checkbox, Stack } from '@mui/material';
// import { VscNewFile } from 'react-icons/vsc';
// import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import { DataGrid } from '@mui/x-data-grid';
// import { useMediaQuery, useTheme } from '@mui/material';
// import { Description } from "@mui/icons-material";
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../../context/AuthContext';
// import { FaUser } from "react-icons/fa";
// import CommonServerDataGrid from "../../components/datagridComponent";

// const normalizeDate = (v) =>
//     typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)
//         ? v.split("-").reverse().join("/")
//         : v;

// // Avatar color helper (same as RN version)
// function stringToColor(string = "") {
//     const colors = [
//         "#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6",
//         "#1abc9c", "#3f51b5", "#e91e63", "#795548", "#00bcd4",
//     ];
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name = "") {
//     return name.trim().charAt(0).toUpperCase() || "C";
// }

// const PurchaseOrderDetails = ({ connectionString, pdfString }) => {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory || null;

//     const theme = useTheme();
//     const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

//     const [loading, setLoading] = useState(false);
//     const [orders, setOrders] = useState([]);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [filterText, setFilterText] = useState("");
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState("");
//     const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//     const [pdfLoading, setPdfLoading] = useState(false);
//     const [loadingPdfId, setLoadingPdfId] = useState(null);
//       const [filterModel, setFilterModel] = useState({ items: [] });
//  const [sortModel, setSortModel] = useState([]);
//     const navigate = useNavigate();
//     const PDF_API_BASE = pdfString;
//     const api = connectionString;

//     const params = { userId, userCategory: role, companyId };

//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });

//     useEffect(() => {
//         (async () => {
//             setLoading(true);
//             try {
//                 const res = await axios.get(`${api}/api/Purchaseorders`, {
//                     params,
//                     headers: { 'Cache-Control': 'no-store' }
//                 });
//                 setOrders(res.data || []);
//             } catch (err) {
//                 console.error('Failed to fetch orders', err);
//                 setOrders([]);
//             } finally {
//                 setLoading(false);
//             }
//         })();
//     }, []);

//     const filteredOrders = useMemo(() => {
//         if (!filterText.trim()) return orders;
//         const lower = filterText.toLowerCase();
//         return orders.filter(order =>
//             String(order.PONumber || "").toLowerCase().includes(lower) ||
//             String(order.PartyName || "").toLowerCase().includes(lower) ||
//             String(order.City || "").toLowerCase().includes(lower)
//         );
//     }, [orders, filterText]);

//     const allVisibleSelected = selectionModel.length === filteredOrders.length && filteredOrders.length > 0;

//     const toggleSelectAll = () => {
//         if (allVisibleSelected) {
//             setSelectionModel([]);
//         } else {
//             setSelectionModel(filteredOrders.map(row => row.POId));
//         }
//     };

//     const handleDelete = async (ids) => {
//         if (ids.length === 0) {
//             setSnackbarMessage("No orders selected for deletion.");
//             setSnackbarSeverity("warning");
//             setSnackbarOpen(true);
//             return;
//         }

//         if (!window.confirm(`Are you sure you want to delete ${ids.length} order(s)?`)) return;

//         try {
//             const payload = { objAryId: ids, companyId, userId };
//             const { data } = await axios.post(`${api}/api/delete-PurcOrders`, payload);

//             const referencedIds = data.referencedIds || [];
//             const totalDeleted = (data.deletedOrders || 0) + (data.deletedPurchaseOrderDetailss || 0);

//             if (totalDeleted > 0) {
//                 setOrders(prev => prev.filter(row => !ids.includes(Number(row.POId)) || referencedIds.includes(Number(row.POId))));
//                 setSelectionModel(prev => prev.filter(id => referencedIds.includes(id)));
//                 setSnackbarMessage(`Deleted ${data.deletedOrders || 0} orders and ${data.deletedPurchaseOrderDetailss || 0} details.`);
//                 setSnackbarSeverity("success");
//             }

//             if (referencedIds.length > 0) {
//                 setSnackbarMessage(`The following ID(s) have references and cannot be deleted: ${referencedIds.join(', ')}`);
//                 setSnackbarSeverity("warning");
//             } else if (totalDeleted === 0) {
//                 setSnackbarMessage("No orders deleted, possibly due to references.");
//                 setSnackbarSeverity("warning");
//             }

//             setSnackbarOpen(true);
//         } catch (err) {
//             console.error('Error deleting orders:', err);
//             setSnackbarMessage("Failed to delete one or more orders.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//         }
//     };

//     const handleSnackbarClose = (event, reason) => {
//         if (reason === 'clickaway') return;
//         setSnackbarOpen(false);
//     };

//     const handleViewClick = async (poId) => {
//         if (!poId || pdfLoading) return;

//         setPdfLoading(true);
//         setLoadingPdfId(poId);

//         const userIdSafe = userId || 'usr1';
//         let formatId = 'format_1';
//         let bookNameToSend = 'PurchaseOrder';
//         let bookIdToSend = null;

//         try {
//             const resp = await axios.get(`${api}/api/companies`, { params: { companyId } });
//             let comps = [];
//             if (Array.isArray(resp?.data)) comps = resp.data;
//             else if (resp?.data?.companies) comps = resp.data.companies;
//             else if (resp?.data) comps = [resp.data];

//             let match = null;
//             for (const c of comps) {
//                 if (Array.isArray(c.formats)) {
//                     for (const f of c.formats) {
//                         const bn = (f.BookName || f.bookName || '').replace(/\s/g, '');
//                         const fn = (f.FormName || f.formName || '').replace(/\s/g, '');
//                         if (/^purchaseorder$/i.test(bn) || /^purchaseorder$/i.test(fn)) {
//                             match = { company: c, format: f };
//                             break;
//                         }
//                     }
//                     if (match) break;
//                 }
//                 if ((c.BookName || c.bookName || '').toLowerCase().includes('purchaseorder')) {
//                     match = { company: c, format: c };
//                     break;
//                 }
//             }

//             if (match) {
//                 const f = match.format;
//                 const foundBookId = f.BookID ?? f.BookId ?? f.bookId ?? null;
//                 if (foundBookId) {
//                     formatId = `format_${foundBookId}`;
//                     bookIdToSend = foundBookId;
//                 } else if (f.FormName || f.formName) {
//                     formatId = String(f.FormName || f.formName);
//                 }
//                 bookNameToSend = f.BookName ?? f.bookName ?? bookNameToSend;
//             }
//         } catch (err) {
//             console.warn("Format detection failed, using defaults", err);
//         }

//         let imageBase64 = null;
//         try {
//             const iconRes = await axios.get(`${api}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
//             if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                 const raw = iconRes.data.imageBase64;
//                 imageBase64 = typeof raw === 'string' ? raw.split('base64,').pop()?.replace(/\s/g, '') || null : null;
//             }
//         } catch (err) {
//             console.warn("Failed to fetch company icon:", err);
//         }

//         try {
//             const poResp = await axios.get(`${api}/api/get-purchase-order-data/${poId}`, {
//                 params: { companyId },
//                 headers: { "Cache-Control": "no-store" }
//             });

//             const { master, details } = poResp.data || {};
//             if (!master) throw new Error("No master data returned");

//             const items = (details || []).map(d => {
//                 const qty = Number(d.Qty) || 0;
//                 const rate = Number(d.Rate) || 0;
//                 const disc = Number(d.Disc) || 0;
//                 const amount = qty * rate * (1 - disc / 100);

//                 return {
//                     hsnCode: d.HSNNo || "",
//                     description: d.productDescription || "",
//                     qty: d.Qty || "",
//                     rate: d.Rate || "",
//                     Unit: d.Unit || "",
//                     discount: d.Disc || "",
//                     cgst: Number(d.CGST || 0),
//                     sgst: Number(d.SGST || 0),
//                     igst: Number(d.IGST || 0),
//                     amount,
//                 };
//             });

//             const pdfData = {
//                 companyId: companyId,
//                 companyName: master.FirmName || "",
//                 address: master.Address || "",
//                 phone: master.MobileNo || "",
//                 gstNo: master.GSTNo || "",
//                 invoiceNo: master.PONumber || "",
//                 referrenceNo: master.PartyPONO || master.RefNo || "",
//                 date: master.PODate ? normalizeDate(master.PODate) : "",
//                 transport: master.Transporter || "SELF",
//                 challanNo: master.lrNumber || "",
//                 poNo: master.Project || "",
//                 state: master.state || "",
//                 stateCode: master.StateCode || "",
//                 LrNo: master.lrNumber || "",
//                 vehNo: master.vehicleNumber || "",
//                 LrDate: master.lrDate ? normalizeDate(master.lrDate) : "",
//                 shipToGstNumber: master.shipToGstNumber || "",
//                 shipToState: master.state || "",
//                 items,
//                 toEmail: master.EmailId || "",
//                 totalAmount: master.grandTotal || 0,
//                 mobileNo: master.MobileNo || "",
//                 basicAmount: Number(master.BasicAmt) || 0,
//                 CGSTAmt: Number(master.CGSTAmt) || 0,
//                 SGSTAmt: Number(master.SGSTAmt) || 0,
//                 IGSTAmt: Number(master.IGSTAmt) || 0,
//                 RoundOff: Number(master.RoundOff) || 0,
//                 BillAmt: Number(master.BillAmt) || 0,
//                 clientState: master.clientState || "",
//                 clientStateCode: master.clientStateCode || "",
//                 imageBase64: imageBase64 || null,
//             };

//             const companyHeader = selectedCompany ? {
//                 CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
//                 Address: selectedCompany.Address || selectedCompany.address || "",
//                 MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
//                 GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
//                 imageBase64: imageBase64 || null
//             } : null;

//             const pdfResp = await axios.post(
//                 `${PDF_API_BASE}/api/pdf/PurchaseOrder/${encodeURIComponent(poId)}`,
//                 {
//                     docId: poId,
//                     userId: userIdSafe,
//                     formatId,
//                     data: pdfData,
//                     company: companyHeader
//                 },
//                 { responseType: "blob" }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF");

//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
//             const newWin = window.open(blobUrl, "_blank");
//             if (newWin) {
//                 newWin.focus();
//                 const timer = setInterval(() => {
//                     if (newWin.closed) {
//                         URL.revokeObjectURL(blobUrl);
//                         clearInterval(timer);
//                     }
//                 }, 1000);
//             } else {
//                 setSnackbarMessage("Popup blocked – PDF opened in same tab");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//                 window.location.href = blobUrl;
//             }
//         } catch (err) {
//             console.error("Purchase Order PDF Error:", err);
//             setSnackbarMessage("Failed to generate Purchase Order PDF");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//         } finally {
//             setPdfLoading(false);
//             setLoadingPdfId(null);
//         }
//     };

//     const columns = [
//         {
//             field: "PODate", headerName: "Order Date", flex: 0.8, sortable: true,
//             valueFormatter: (params) => {
//                 const v = params.value;
//                 if (typeof v !== "string" || !v.includes("-")) return "-";
//                 const [yyyy, mm, dd] = v.split("-");
//                 return `${dd}/${mm}/${yyyy}`;
//             },
//         },
//         {
//             field: "PONumber", headerName: "Order No.", flex: 1.2,
//             renderCell: (params) => (
//                 <Box onClick={() => navigate(`/main/Purchase-OrderMaster-edit/${params.row.POId}`)} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}> {params.value} </Box>
//             ),
//         },
//         { field: "PartyPONO", headerName: "Ref No.", flex: 1 },
//         {
//             field: "PartyName", headerName: "Client Details", flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <FaUser color="#FF9800" />
//                         <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant="body2" color="text.secondary">📲 {params.row.MobileNo || '-'} </Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: "location", headerName: "Location", flex: 1.5,
//             renderCell: (params) => (
//                 <Box>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         ...(role !== "SalesMan"
//             ? [{
//                 field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
//                 valueFormatter: (params) => {
//                     let num = params.value;
//                     if (typeof num === "string") num = parseFloat(num);
//                     if (typeof num !== "number" || isNaN(num)) return "-";
//                     return `₹${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//                 },
//             }]
//             : []),
//         {
//             field: "view", headerName: "View", flex: 0.4, sortable: false, align: "right", headerAlign: "right",
//             renderCell: (params) => {
//                 const thisId = params.row.POId;
//                 if (loadingPdfId && String(loadingPdfId) === String(thisId)) {
//                     return <CircularProgress size={20} />;
//                 }
//                 return (
//                     <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleViewClick(params.row.POId); }} >
//                         <PrintIcon />
//                     </IconButton>
//                 );
//             },
//         },
//     ];

//     if (role !== "User") {
//         columns.push({
//             field: "delete", headerName: "Delete", flex: 0.4, sortable: false, align: "right", headerAlign: "right",
//             renderCell: (params) => {
//                 const isSelected = selectionModel.includes(params.row.POId);
//                 return (
//                     <IconButton color="error" size="small" disabled={!isSelected} onClick={(e) => { e.stopPropagation(); handleDelete(selectionModel); }} >
//                         <DeleteIcon />
//                     </IconButton>
//                 );
//             },
//         });
//     }

//     const renderMobileCards = () => {
//         if (loading) return <Box textAlign="center" py={6}><CircularProgress /></Box>;
//         if (filteredOrders.length === 0) return <Typography textAlign="center" py={6} color="text.secondary">No order records found.</Typography>;

//         return filteredOrders.map((row) => {
//             const isSelected = selectionModel.includes(row.POId);
//             const avatarColor = stringToColor(row.PartyName);

//             return (
//                 <Paper
//                     key={row.POId}
//                     elevation={3}
//                     onClick={() => navigate(`/main/Purchase-OrderMaster-edit/${row.POId}`)}
//                     sx={{
//                         mb: 2,
//                         borderLeft: '6px solid #165bb5',
//                         borderRadius: 2,
//                         overflow: 'hidden',
//                         cursor: 'pointer',
//                         transition: 'box-shadow 0.2s',
//                         '&:hover': { boxShadow: 6 },
//                         bgcolor: 'background.paper',
//                     }}
//                 >
//                     <Box sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
//                         {/* Top Row: Checkbox + Avatar + Name/Location + Date */}
//                         <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
//                                 {role !== "User" && (
//                                     <Checkbox
//                                         checked={isSelected}
//                                         onChange={(e) => {
//                                             e.stopPropagation();
//                                             setSelectionModel(prev =>
//                                                 prev.includes(row.POId)
//                                                     ? prev.filter(id => id !== row.POId)
//                                                     : [...prev, row.POId]
//                                             );
//                                         }}
//                                         onClick={(e) => e.stopPropagation()}
//                                         size="small"
//                                     />
//                                 )}
//                                 <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, flexShrink: 0 }}>
//                                     {getInitials(row.PartyName)}
//                                 </Avatar>
//                                 <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
//                                     <Typography variant="subtitle1" fontWeight={600} noWrap>
//                                         {row.PartyName || "N/A"}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary" noWrap>
//                                         {row.City && row.state ? `${row.City}, ${row.state}` : row.City || row.state || "—"}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 1 }} noWrap>
//                                 {normalizeDate(row.PODate)}
//                             </Typography>
//                         </Box>

//                         {/* Order No + Amount */}
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
//                                 <Description fontSize="small" sx={{ color: 'text.secondary', mr: 1, flexShrink: 0 }} />
//                                 <Typography variant="body2" color="text.secondary" noWrap>
//                                     {row.PONumber || "-"}
//                                 </Typography>
//                             </Box>
//                             {role !== "SalesMan" && (
//                                 <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                     ₹{Number(row.BillAmt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                                 </Typography>
//                             )}
//                         </Box>

//                         {/* Ref No */}
//                         {row.PartyPONO && (
//                             <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
//                                 <Typography variant="body2" color="text.secondary" sx={{ mr: 1, flexShrink: 0 }}>
//                                     Ref:
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary" noWrap>
//                                     {row.PartyPONO}
//                                 </Typography>
//                             </Box>
//                         )}

//                         <Divider sx={{ my: 1.5 }} />

//                         {/* Bottom: Contact + View PDF */}
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
//                                 <FaUser color="#FF9800" fontSize={18} sx={{ mr: 1, flexShrink: 0 }} />
//                                 <Typography variant="body2" color="text.secondary" noWrap>
//                                     {row.ContactPerson || '-'}
//                                 </Typography>
//                             </Box>
//                             <IconButton
//                                 color="primary"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleViewClick(row.POId);
//                                 }}
//                                 sx={{ flexShrink: 0 }}
//                             >
//                                 {loadingPdfId === row.POId ? <CircularProgress size={20} /> : <PrintIcon />}
//                             </IconButton>
//                         </Box>
//                     </Box>
//                 </Paper>
//             );
//         });
//     };

//     return (
//         <Box p={2}>
//             <Grid container justifyContent="space-between" alignItems="center" mb={2}>
//                 <Box display="flex" alignItems="center" gap={1}>
//                     <IconButton component={Link} to="/main/Purchase-OrderMaster-stepper" size="small" sx={{ color: 'orange' }}>
//                         <VscNewFile size={20} />
//                     </IconButton>
//                     <Typography variant="h5" fontWeight="bold">New Purchase Order</Typography>
//                 </Box>
//             </Grid>

//             <Paper sx={{ borderRadius: 2, p: { xs: 2, md: 3 }, ml: 2, overflow: 'hidden' }}>
//                 <Typography variant="h6" fontWeight={600} mb={2}>Purchase Order List</Typography>

//                 {/* Search Bar - Mobile Only */}
//                 {!isDesktop && (
//                     <TextField fullWidth size="small" placeholder="Search by Order No, Client, City..." value={filterText} onChange={(e) => setFilterText(e.target.value)} sx={{ mb: 2 }}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon />
//                                 </InputAdornment>
//                             ),
//                         }}
//                     />
//                 )}

//                 {/* Bulk Action Bar - Mobile Only */}
//                 {!isDesktop && role !== "User" && selectionModel.length > 0 && (
//                     <Paper elevation={2} sx={{ p: 1.5, mb: 2, borderRadius: 2, bgcolor: 'background.default' }}>
//                         <Box display="flex" justifyContent="space-between" alignItems="center">
//                             <Box display="flex" alignItems="center">
//                                 <Checkbox checked={allVisibleSelected} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2">{selectionModel.length} selected</Typography>
//                             </Box>
//                             <IconButton color="error" onClick={() => handleDelete(selectionModel)}>
//                                 <DeleteIcon />
//                             </IconButton>
//                         </Box>
//                     </Paper>
//                 )}

//                 {/* Desktop: DataGrid | Mobile: Cards */}
//                 {isDesktop ? (
//                    <CommonServerDataGrid
//                      data={filteredOrders}
//                                 columns={columns}
//                                 getRowId={(row) => row.POId}
//                                 role={role}
//                                 pageSizeOptions={[25, 50, 100]}
//                                 selectionModel={selectionModel}
//                                 onSelectionModelChange={setSelectionModel}
//                                 onPageChange={({ page, pageSize }) => {
//                                     setPaginationModel({ page, pageSize });
//                                 }}
//                                 onFilterChange={setFilterModel}
//                                 onSortChange={setSortModel}
//                     />
//                 ) : (
//                     <Box sx={{ px: { xs: 0.5, sm: 1 } }}>
//                         {renderMobileCards()}
//                     </Box>
//                 )}
//             </Paper>

//             {/* Global PDF Loading Indicator */}
//             {pdfLoading && (
//                 <Box mt={3} display="flex" alignItems="center" justifyContent="center" gap={1}>
//                     <CircularProgress size={18} />
//                     <Typography>Preparing PDF...</Typography>
//                 </Box>
//             )}

//             {/* Snackbar */}
//             <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
//                 <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
//                     {snackbarMessage}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default PurchaseOrderDetails;





